<template>
	<div>
		<TopPanel 
			noSearch
			hideAdd
			showCustomer
		/>

		<div class="statistics-content-container">
			<Statistics />
		</div>
	</div>
</template>

<script>
import Statistics from './components/Statistics';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		Statistics,
		TopPanel
	}
};
</script>

<style lang="scss" scoped>
.statistics-content-container {
	margin-top: 3rem;
}
</style>
